import { loadingText } from './LoadingView.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./LoadingView.scss');

export const LoadingView = observer(function LoadingView() {
    return (
        <div className={styles.container}>
            <Spinner size={SpinnerSize.medium} />
            <div className={styles.text}>{loc(loadingText)}</div>
        </div>
    );
});
